 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import A1_TITLE from '@/components/01_Title'
 import UNTITLED128 from '@/components/Untitled128'
 import UNTITLED129 from '@/components/Untitled129'
 import UNTITLED130 from '@/components/Untitled130'
 import UNTITLED131 from '@/components/Untitled131'
 import UNTITLED132 from '@/components/Untitled132'
 import UNTITLED133 from '@/components/Untitled133'
 import UNTITLED134 from '@/components/Untitled134'
 import UNTITLED135 from '@/components/Untitled135'
 import UNTITLED136 from '@/components/Untitled136'
 import UNTITLED137 from '@/components/Untitled137'
 import UNTITLED138 from '@/components/Untitled138'
 import UNTITLED139 from '@/components/Untitled139'
 import UNTITLED140 from '@/components/Untitled140'
 import UNTITLED141 from '@/components/Untitled141'
 import UNTITLED142 from '@/components/Untitled142'
 import UNTITLED143 from '@/components/Untitled143'
 import UNTITLED144 from '@/components/Untitled144'
 import UNTITLED145 from '@/components/Untitled145'
 import UNTITLED146 from '@/components/Untitled146'
 import UNTITLED147 from '@/components/Untitled147'
 import UNTITLED148 from '@/components/Untitled148'
 import UNTITLED149 from '@/components/Untitled149'
 import UNTITLED150 from '@/components/Untitled150'
 import UNTITLED151 from '@/components/Untitled151'
 import UNTITLED152 from '@/components/Untitled152'
 import UNTITLED153 from '@/components/Untitled153'
 import UNTITLED154 from '@/components/Untitled154'
 import PREVIEWPREVIEW from '@/components/Preview/Preview'
 import PREVIEWPREVIEWCOVER from '@/components/Preview/previewcover'
 import PREVIEWUNTITLED228 from '@/components/Preview/Untitled228'
 import PREVIEWUNTITLED229 from '@/components/Preview/Untitled229'
 import PREVIEWUNTITLED230 from '@/components/Preview/Untitled230'
 import PREVIEWUNTITLED231 from '@/components/Preview/Untitled231'
 import COPYRIGHT from '@/components/copyright'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/01_Title",
 			"name" : "01_Title",
 			"component" : A1_TITLE
 		},
 		{
 			"path" : "/Untitled128",
 			"name" : "Untitled128",
 			"component" : UNTITLED128
 		},
 		{
 			"path" : "/Untitled129",
 			"name" : "Untitled129",
 			"component" : UNTITLED129
 		},
 		{
 			"path" : "/Untitled130",
 			"name" : "Untitled130",
 			"component" : UNTITLED130
 		},
 		{
 			"path" : "/Untitled131",
 			"name" : "Untitled131",
 			"component" : UNTITLED131
 		},
 		{
 			"path" : "/Untitled132",
 			"name" : "Untitled132",
 			"component" : UNTITLED132
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js